import React from "react";

import { Outlet } from "react-router-dom";

import Navbar from "./Navbar";

import Sidebar from "./Sidebar";

import '../../assets/admin/css/sb-admin-2.min.css';


const AdminMasterLayout = () => {
    return (
        <div id="wrapper">
            <Sidebar/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <Navbar />
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xl-12">
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminMasterLayout;